export const contactsData = {
    email: 'mdmahbubur511@gmail.com',
    phone: '+9660572188994',
    address: 'Riyadh, Saudi Arabia ',

    sheetAPI: ''
}